import axios from 'axios'

let lang = document.querySelector('#revenge-bet-console').getAttribute('lang')
  ? document.querySelector('#revenge-bet-console').getAttribute('lang')
  : process.env.VUE_APP_FALLBACK_LOCALE

if (lang.includes('-')) {
  const langSplit = lang.split('-')
  lang = langSplit[0]
}

if (lang.includes('_')) {
  const langSplit = lang.split('_')
  lang = langSplit[0]
}

const state = {
  name: 'Revenge BetConsole',
  urlApi: process.env.VUE_APP_URL_API,
  betApiUrl: process.env.VUE_APP_BET_API_URL,
  urlRules: process.env.VUE_APP_URL_RULES,
  platform_id:
    document.querySelector('#revenge-bet-console').getAttribute('platform') !=
    '0'
      ? document.querySelector('#revenge-bet-console').getAttribute('platform')
      : 0,
  token: '',
  language: lang,
  snackbar: false,
  snackbar_text: '',
  platform_settings: [],
  results: [],
  banners: [],
  showquickbet: false, // true for  move directly to quick bet page for agency
  nextevent: false,
  eventday: false,
  cashout: false,
  cashoutV2: false,
  cashoutlive: false,
  voidAsLose: false,
  electron: false,
  icon: 'icons',
  gameConsole: 'default',
  stream_live: false,
  enable_central_banner: true,
  featuredTournamentAutoLoad: false,
  featuredTournamentWidget: false,
  featuredTournamentsInfo: [],
  programOpen: false,
  shortCode: false,
  enableClearCartAtPlaceBet: false,
  enabledTaxOnWon: false,
  percentageTaxValueOnWon: 0,
  enableAgencyCanPlayForUser: false,
  enableMobileBottomToolbar: false,
  explodeMarketOnMobileDevice: false,
  proxyUrl: null,
  enableAutoRecharge: false,
  customerId: null,
  showMultiplicityLegendMobile: false,
  enableTreeWithPlayerOutcomes: false,
  quickBetEnabled: false,
  allowIntegralLiveBet: false,
  disableIdleUICheck: false,
  heightOfParentIframe: null,
  cashoutApiPollIntervalSec: 60,
}

const getters = {
  getName: state => {
    return state.name
  },
  getUrlApi: state => {
    return state.urlApi
  },
  getBetApiUrl: state => {
    return state.betApiUrl
  },
  getUrlRules: state => {
    return state.urlRules
  },
  getPlatformId: state => {
    return state.platform_id
  },
  getToken: state => {
    return state.token
  },
  getLanguage: state => {
    return state.language
  },
  getSnackbar: state => {
    return state.snackbar
  },
  getSnackbarText: state => {
    return state.snackbar_text
  },
  getPlatformSettings: state => {
    return state.platform_settings
  },
  getResults: state => {
    return state.results
  },
  getBanners: state => {
    return state.banners
  },
  getShowQuickbet: state => {
    return state.showquickbet
  },
  getEventDay: state => {
    return state.eventday
  },
  getCashout: state => {
    return state.cashout
  },
  getCashoutV2: state => {
    return state.cashoutV2
  },
  getCashoutLive: state => {
    return state.cashoutlive
  },
  getNextEvent: state => {
    return state.nextevent
  },
  getVoidAsLose: state => {
    return state.voidAsLose
  },
  getElectron: state => {
    return state.electron
  },
  getIcon: state => {
    return state.icon
  },
  getGameConsole: state => {
    return state.gameConsole
  },
  getStreamLive: state => {
    return state.stream_live
  },
  getEnableCentralBanner: state => {
    return state.enable_central_banner
  },
  getFeaturedTournamentAutoLoad: state => {
    return state.featuredTournamentAutoLoad
  },
  getFeaturedTournamentWidget: state => {
    return state.featuredTournamentWidget
  },
  getFeaturedTournamentsInfo: state => {
    return state.featuredTournamentsInfo
  },
  getProgramOpen: state => {
    return state.programOpen
  },
  getShortCode: state => {
    return state.shortCode
  },
  getEnableClearCartAtPlaceBet: state => {
    return state.enableClearCartAtPlaceBet
  },
  getEnabledTaxOnWon: state => {
    return state.enabledTaxOnWon
  },
  getPercentageTaxValueOnWon: state => {
    return state.percentageTaxValueOnWon
  },
  getEnableAgencyCanPlayForUser: state => {
    return state.enableAgencyCanPlayForUser
  },
  getEnableMobileBottomToolbar: state => {
    return state.enableMobileBottomToolbar
  },
  getExplodeMarketOnMobileDevice: state => {
    return state.explodeMarketOnMobileDevice
  },
  getProxyUrl: state => {
    return state.proxyUrl
  },
  getEnableAutoRecharge: state => {
    return state.enableAutoRecharge
  },
  getCustomerId: state => {
    return state.customerId
  },
  getShowMultiplicityLegendMobile: state => {
    return state.showMultiplicityLegendMobile
  },
  getEnableTreeWithPlayerOutcomes: state => {
    return state.enableTreeWithPlayerOutcomes
  },
  quickBetEnabled: state => {
    return state.quickBetEnabled
  },
  getAllowIntegralLiveBet: state => {
    return state.allowIntegralLiveBet
  },
  getDisableIdleUICheck: state => {
    return state.disableIdleUICheck
  },
  getCashoutApiPollIntervalSec: state => {
    return state.cashoutApiPollIntervalSec
  },
  getHeightOfParentIframe: state => {
    return state.heightOfParentIframe
  },
}

const actions = {
  async setName(context, payload) {
    context.commit('SET_NAME', payload)
  },

  async setUrlApi(context, payload) {
    context.commit('SET_URL_API', payload)
  },

  async setBetApiUrl(context, payload) {
    context.commit('SET_BET_API_URL', payload)
  },

  async setUrlRules(context, payload) {
    context.commit('SET_URL_RULES', payload)
  },

  async setPlatformId(context, payload) {
    context.commit('SET_PLATFORM_ID', payload)
  },

  async setToken(context, payload) {
    context.commit('SET_TOKEN', payload)
  },
  async setIcon(context, payload) {
    context.commit('SET_ICON', payload)
  },

  async setLanguage(context, payload) {
    context.commit('SET_LANGUAGE', payload)
  },

  async setSnackbar(context, payload) {
    context.commit('SET_SNACKBAR', payload)
  },

  async setSnackbarText(context, payload) {
    context.commit('SET_SNACKBAR_TEXT', payload)
  },

  async setPlatformSettings(context, payload) {
    context.commit('SET_PLATFORM_SETTINGS', payload)
  },
  async setResults(context, payload) {
    context.commit('SET_RESULTS', payload)
  },
  async setBanners(context, payload) {
    context.commit('SET_BANNERS', payload)
  },
  async setShowQuickbet(context, payload) {
    context.commit('SET_SHOW_QUICKBET', payload) // true for  move directly to quick bet page for agency
  },
  async setVoidAsLose(context, payload) {
    context.commit('SET_VOID_AS_LOSE', payload)
  },

  async setElectron(context, payload) {
    context.commit('SET_ELECTRON', payload)
  },

  async setStreamLive(context, payload) {
    context.commit('SET_STREAM_LIVE', payload)
  },
  async fetchFeaturedTournaments(context, payload) {
    const platformId = context.rootGetters['settings/getPlatformId']
    const url =
      `${context.rootGetters['settings/getUrlApi']}/tournaments/featured/` +
      platformId +
      '?language=' +
      context.rootGetters['settings/getLanguage']

    if (platformId != null) {
      return await axios.get(url, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
    }
  },
  async setStatusBannerCentral(context, payload) {
    context.commit('SET_ENABLE_CENTRAL_BANNER_STATUS', payload)
  },
  async setFeaturedTournamentsInfo(context, payload) {
    context.commit('SET_FEATURED_TOURNAMENTS_INFO', payload)
  },
  async setProgramOpen(context, payload) {
    context.commit('SET_PROGRAM_OPEN', payload)
  },

  async setEnableAgencyCanPlayForUser(context, payload) {
    context.commit('SET_AGENCY_CAN_PLAY_FOR_USER', payload)
  },

  async setExplodeMarketsOnMobileDevice(context, payload) {
    context.commit('SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE', payload)
  },
  async setProxyUrl(context, payload) {
    context.commit('SET_PROXY_URL', payload)
  },
  async setEnableAutoRecharge(context, payload) {
    context.commit('SET_ENABLE_AUTO_RECHARGE', payload)
  },
  async setCustomerId(context, payload) {
    context.commit('SET_CUSTOMER_ID', payload)
  },
  async setQuickBetEnabled(context, payload) {
    context.commit('SET_QUICK_BET_ENABLED', payload)
  },
  async setHeightOfParentIframe(context, payload) {
    context.commit('SET_HEIGHT_OF_PARENT_IFRAME', payload)
  },
  async fetchMyPrintTemplates(context, payload) {
    const platformId = payload
    const url = `${context.rootGetters['settings/getUrlApi']}/skins/me/platforms/${platformId}/prints/templates`

    return await axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })
      .then(async res => {
        return res.data
      })
      .catch(err => {
        console.log(err)
      })
  },
}

const mutations = {
  SET_NAME: (state, value) => {
    state.name = value
  },
  SET_URL_API: (state, value) => {
    state.urlApi = value
  },
  SET_BET_API_URL: (state, value) => {
    state.betApiUrl = value
  },
  SET_URL_RULES: (state, value) => {
    state.urlRules = value
  },
  SET_PLATFORM_ID: (state, value) => {
    state.platform_id = value
  },
  SET_TOKEN: (state, value) => {
    state.token = value
  },
  SET_LANGUAGE: (state, value) => {
    state.language = value
  },
  SET_SNACKBAR: (state, value) => {
    state.snackbar = value
  },
  SET_SNACKBAR_TEXT: (state, value) => {
    state.snackbar_text = value
  },
  SET_PLATFORM_SETTINGS: (state, value) => {
    state.platform_settings = value
  },
  SET_RESULTS: (state, value) => {
    state.results = value
  },
  SET_BANNERS: (state, value) => {
    state.banners = []
    state.banners = value
  },
  SET_SHOW_QUICKBET: (state, value) => {
    state.showquickbet = value
  },
  SET_ICON: (state, value) => {
    state.icon = value
  },
  SET_EVENT_DAY: (state, value) => {
    state.eventday = value
  },
  SET_CASH_OUT: (state, value) => {
    state.cashout = value
  },
  SET_CASH_OUT_V2: (state, value) => {
    state.cashoutV2 = value
  },
  SET_CASH_OUT_LIVE: (state, value) => {
    state.cashoutlive = value
  },
  SET_NEXT_EVENT: (state, value) => {
    state.nextevent = value
  },
  SET_VOID_AS_LOSE: (state, value) => {
    state.voidAsLose = value
  },
  SET_ELECTRON: (state, value) => {
    state.electron = value
  },
  SET_GAME_CONSOLE: (state, value) => {
    state.gameConsole = value != null ? value : 'default'
  },
  SET_STREAM_LIVE: (state, value) => {
    state.stream_live = value
  },
  SET_ENABLE_CENTRAL_BANNER_STATUS: (state, value) => {
    state.enable_central_banner = value
  },

  SET_FEATURED_TOURNAMENT_AUTOLOAD: (state, value) => {
    state.featuredTournamentAutoLoad = value
  },

  SET_FEATURED_TOURNAMENT_WIDGET: (state, value) => {
    state.featuredTournamentWidget = value
  },
  SET_FEATURED_TOURNAMENTS_INFO: (state, value) => {
    state.featuredTournamentsInfo = value
  },
  SET_PROGRAM_OPEN: (state, value) => {
    state.programOpen = value
  },
  SET_SHORT_CODE: (state, value) => {
    state.shortCode = value != null ? value : false
  },
  SET_ENABLE_CLEAR_CART_AT_PLACE_BET: (state, value) => {
    state.enableClearCartAtPlaceBet = value != null ? value : false
  },
  SET_ENABLE_TAX_ON_WON: (state, value) => {
    state.enabledTaxOnWon = value != null ? value : false
  },
  SET_PERCENTAGE_TAX_VALUE_ON_WON: (state, value) => {
    if (state.enabledTaxOnWon === true) {
      state.percentageTaxValueOnWon = value != null && +value >= 0 ? value : 0
    } else {
      state.percentageTaxValueOnWon = 0
    }
  },

  SET_AGENCY_CAN_PLAY_FOR_USER: (state, value) => {
    state.enableAgencyCanPlayForUser = value != null ? value : false
  },
  SET_ENABLE_MOBILE_BOTTOM_TOOLBAR: (state, value) => {
    state.enableMobileBottomToolbar = value != null ? value : false
  },

  SET_EXPLODE_MARKETS_ON_MOBILE_DEVICE: (state, value) => {
    state.explodeMarketOnMobileDevice = value != null ? value : false
  },
  SET_PROXY_URL: (state, value) => {
    state.proxyUrl = value != null ? value : null
  },
  SET_ENABLE_AUTO_RECHARGE: (state, value) => {
    state.enableAutoRecharge = value != null ? value : false
  },
  SET_CUSTOMER_ID: (state, value) => {
    state.customerId = value != null ? value : null
  },
  SET_SHOW_MULTIPLICITY_LEGEND_ON_MOBILE_DEVICE: (state, value) => {
    state.showMultiplicityLegendMobile = value != null ? value : false
  },
  SET_ENABLE_TREE_WITH_PLAYER_OUTCOMES: (state, value) => {
    state.enableTreeWithPlayerOutcomes = value != null ? value : false
  },
  SET_QUICK_BET_ENABLED: (state, value) => {
    state.quickBetEnabled = value != null ? value : false
  },
  SET_ALLOW_INTEGRAL_LIVE_BET: (state, value) => {
    state.allowIntegralLiveBet = value != null ? value : false
  },
  SET_DISABLE_UI_CHECK: (state, value) => {
    state.disableIdleUICheck = value != null ? value : false
  },
  SET_HEIGHT_OF_PARENT_IFRAME: (state, value) => {
    state.heightOfParentIframe = value
  },
  SET_CASHOUT_API_POLL_INTERVAL_SEC: (state, value) => {
    const num = Number(value)
    state.cashoutApiPollIntervalSec =
      Number.isFinite(num) && num > 60 ? num : 60
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
